
import React from 'react';
import elements from '@/components/elements';
import ListSubheader from '@mui/material/ListSubheader';
import Typography from '@mui/material/Typography';
import { messages } from '@/hooks/approval/useApprovals';
import Tooltip from '@/components/mui/Tooltip';
import IconButton from '@mui/material/IconButton';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useIntl } from 'react-intl';
import { styled } from '@mui/material/styles';

const MenuList = styled('ul')(() => ({ padding: 0 }));

const RenderApproversGroup = (params) => {
  const { group, children } = params;
  const { formatMessage } = useIntl();

  return (
    <li
      key={group}
      data-element={`${elements.content.documents.approvals.autocompleteOptions.groupsContainer}.${group}`}
    >
      <ListSubheader
        component="div"
        sx={{ top: (theme) => theme.spacing(-1), zIndex: 10, display: 'flex', gap: 1, alignItems: 'flex-end' }}
      >
        <Typography sx={{ color: 'primary.main' }} variant="overline">
          {formatMessage(messages[group], { count: children.length })}
        </Typography>
        {!!messages[group]?.hintText && (
          <Tooltip t={formatMessage(messages[group].hintText)} placement="right">
            <IconButton size="small">
              <InfoOutlinedIcon sx={{ color: 'grey.600' }} />
            </IconButton>
          </Tooltip>
        )}
      </ListSubheader>
      <MenuList>{children}</MenuList>
    </li>
  );
};

export default RenderApproversGroup;
